import React from "react";
import "../../../styles/contactos.css";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import { withNamespaces } from "react-i18next";

const EscolasPoli = ({ t }) => {
  
  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_escolas"
      >
        {/* 1 - ESAN */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="esan">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEsan"
              aria-expanded="true"
              aria-controls="cEsan"
            >
              {t('moduleContactosEstruturas:S5.A.A1.T')}
            </button>
          </h2>
          <div
            id="cEsan"
            className="accordion-collapse collapse"
            aria-labelledby="esan"
            data-bs-parent="#accordionExample_escolas"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S5.A.A1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S5.A.A1.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S5.A.A1.P3')}>
                    {t('moduleContactosEstruturas:S5.A.A1.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S5.A.A1.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - ESSUA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="essua">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEssua"
              aria-expanded="true"
              aria-controls="cEssua"
            >
              {t('moduleContactosEstruturas:S5.A.A2.T')}
            </button>
          </h2>
          <div
            id="cEssua"
            className="accordion-collapse collapse"
            aria-labelledby="essua"
            data-bs-parent="#accordionExample_escolas"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S5.A.A2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S5.A.A2.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A2.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S5.A.A2.P3')}>
                    {t('moduleContactosEstruturas:S5.A.A2.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S5.A.A2.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - ESTGA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="estga">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEstga"
              aria-expanded="true"
              aria-controls="cEstga"
            >
              {t('moduleContactosEstruturas:S5.A.A3.T')}
            </button>
          </h2>
          <div
            id="cEstga"
            className="accordion-collapse collapse"
            aria-labelledby="estga"
            data-bs-parent="#accordionExample_escolas"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S5.A.A3.P1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A3.P1.P1'))}
                  </a>
                  {t('moduleContactosEstruturas:S5.A.A3.P1.P3')}
                  <a className="link" rel="noreferrer" href="tel:+351234611501">
                    +351 234 611 501
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S5.A.A3.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A3.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S5.A.A3.P3')}>
                    {t('moduleContactosEstruturas:S5.A.A3.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S5.A.A3.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - ISCA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="isca">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cIsca"
              aria-expanded="true"
              aria-controls="cIsca"
            >
              {t('moduleContactosEstruturas:S5.A.A4.T')}
            </button>
          </h2>
          <div
            id="cIsca"
            className="accordion-collapse collapse"
            aria-labelledby="isca"
            data-bs-parent="#accordionExample_escolas"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S5.A.A4.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A4.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S5.A.A4.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S5.A.A4.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S5.A.A4.P3')}>
                    {t('moduleContactosEstruturas:S5.A.A4.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S5.A.A4.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(EscolasPoli);

